export default {
  layouts: {
    acquring: {
      balances: `To'lovlar ro'yxati`,
      scoring: 'Kartani baholash',
      searchClients: 'Mijozni qidirish',
    },
  },
};
